import { render, staticRenderFns } from "./addresses.vue?vue&type=template&id=3153e3a7&scoped=true"
import script from "./addresses.vue?vue&type=script&lang=js"
export * from "./addresses.vue?vue&type=script&lang=js"
import style0 from "./addresses.vue?vue&type=style&index=0&id=3153e3a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3153e3a7",
  null
  
)

export default component.exports